import { updateLps } from './updateLps';

export const handleReorder = (
  ev: any,
  arrayDataSource: any,
  handleLpsUpdate: boolean = true,
  callback?: (dataArr?: any, reorderedItems?: any) => void
) => {
  const dataArr = arrayDataSource.current._array;

  const visibleRows = ev.component.getVisibleRows();
  const toIndex = dataArr.findIndex(
    (x: any) => x.Id === visibleRows[ev.toIndex].data.Id
  );
  const fromIndex = dataArr.findIndex((x: any) => x.Id === ev.itemData.Id);

  const reorderedItems = {
    grabbed: dataArr[fromIndex],
    replaced: dataArr[toIndex]
  };

  dataArr.splice(fromIndex, 1);
  dataArr.splice(toIndex, 0, ev.itemData);

  if (handleLpsUpdate) {
    updateLps(arrayDataSource.current, dataArr);
  }

  if (callback) {
    callback(dataArr, reorderedItems);
  }

  ev.component.refresh();
};
